// 已迁移 zoneless 变更检测：移除 zone.js 依赖后由 Angular 内部调度器驱动 CD，
// 组件侧须保证 OnPush 下写入模板消费状态时主动标记（markForCheck / AsyncPipe / signal）
import { enableProdMode, provideZonelessChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { tracker } from '@fuulea/monitor/web';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { getUid } from '@common';

if (environment.production) {
  enableProdMode();
}

// 初始化监控 SDK
tracker.init({
  school: window.location.hostname,
  module: 'venus-ui',
  getToken: () => localStorage.getItem('jwt-token'),
  getUUID: () => localStorage.getItem('uuid') || getUid(),
});

platformBrowserDynamic().bootstrapModule(AppModule, { applicationProviders: [provideZonelessChangeDetection()] });
